import { ReactNode } from 'react';
import { attempt } from 'yoso';
import { AccordionContextValue, useAccordion } from '~/components/Accordion/v2/Accordion.hooks';
import { Collapse, CollapseProps } from '~/components/Collapse/Collapse';

export type AccordionBodyProps = {
  children?: ReactNode | ((value: AccordionContextValue) => ReactNode);
} & Omit<CollapseProps, 'children'>;
export const AccordionBody = ({ children, ...props }: AccordionBodyProps) => {
  const context = useAccordion();
  return (
    <Collapse {...props} active={context.active}>
      {attempt(children, context)}
    </Collapse>
  );
};
